<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */
    import BasicMessage from './BasicMessage.svelte';
    import HblMessage from './HblMessage.svelte';

    const reportComponents = Object.freeze({
        default: BasicMessage,
        hbl: HblMessage
    });

    /**
     * Abstraction component to display a reportComponent
     * The reportComponent can be changed by specifying its provider name and props
     * @property {String} itemIdentifier
     * @property {import('./typings').PlagiarismCheckReport} report - type and props for the reportComponent
     */
    let { itemIdentifier, report = {} } = $props();

    // svelte-ignore state_referenced_locally
    const provider = report.provider || 'default';
    let ReportComponent = reportComponents[provider];
</script>

<ReportComponent {itemIdentifier} {report} />
